export const SENTRY_RELEASE = Zeplin.mwConfig.sentryRelease;
export const WEBAPP_VERSION = Zeplin.mwConfig.version;
